/**
 * PLOT-REVEAL
 * Révèle un graphique Plotly au chargement : balayage de gauche à droite pour des barres horizontales (elles
 * « grandissent » depuis la gauche) ou fondu avec léger zoom pour un nuage de points.
 * Plotly n'a pas d'animation d'entrée : on anime le conteneur, ce qui garde intacts le survol, le clic et l'export.
 * Désactivé pendant un export ou avec « réduire les animations ».
 */
import { motion } from "framer-motion"
import { useAnimationsDisabled } from "@/utils/animation-mode.utils"

interface OwnProps {
  children?: React.ReactNode
  //Style du conteneur animé : il remplace le graphique dans la mise en page de son parent, et doit donc en reprendre
  //le rôle (par exemple `display: flex` pour qu'un graphique sans hauteur fixée s'étire encore à la hauteur de la ligne)
  style?: React.CSSProperties
  variant?: "wipe" | "fade"
  duration?: number
  delay?: number
}

function PlotReveal(props: OwnProps) {
  const isDisabled = useAnimationsDisabled()
  const duration = props.duration ?? (props.variant === "fade" ? 0.5 : 0.9)

  if (isDisabled) return <>{props.children}</>

  return props.variant === "fade" ? (
    <motion.div
      style={props.style}
      initial={{ opacity: 0, scale: 0.97 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration, delay: props.delay ?? 0, ease: [0.16, 1, 0.3, 1] }}>
      {props.children}
    </motion.div>
  ) : (
    <motion.div
      style={props.style}
      initial={{ clipPath: "inset(0 100% 0 0)" }}
      animate={{ clipPath: "inset(0 0% 0 0)" }}
      transition={{ duration, delay: props.delay ?? 0.1, ease: [0.22, 1, 0.36, 1] }}>
      {props.children}
    </motion.div>
  )
}

export default PlotReveal
